import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "pt-128 pb-128 pt-64-xs pb-64-xs grid grid--column-40-60 grid--column-full-xs" }
const _hoisted_4 = { class: "color heading bold" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  class: "heading",
  href: "mailto:info@lennarthakker.com"
}, " info@lennarthakker.com ", -1)
const _hoisted_6 = { class: "pb-32 space-between block-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('footer.collaborate')), 1),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          class: "block-xs",
          to: "/"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" © lennarthakker.com " + _toDisplayString(_ctx.currentYear), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}